import CoinPage from './pages/CoinPage.svelte';
export default [
    { path: '/coins', component: CoinPage }
];
